import { ReactComponent as Logo } from './logo/logo-hedgehog.svg';

const PRIMARY = {
    lighter: '#bbb2ff',
    light: '#625e81',
    main: '#543ef9',
    dark: '#4733dc',
    darker: '#252550',
    contrastText: '#fff'
};

const SECONDARY = {
    lighter: '#f580f7',
    light: '#ab27ad',
    main: '#ab27ad',
    dark: '#7a1c82',
    darker: '#511257',
    contrastText: '#fff'
};

const INFO = {
    lighter: '#bef941',
    light: '#bef941',
    main: '#9cd430',
    dark: '#7faa27',
    darker: '#60801d',
    contrastText: '#000'
};

const SUCCESS = {
    lighter: '#DFFFE0',
    light: '#B3F5B0',
    main: '#81E979',
    dark: '#57C553',
    darker: '#2A8F2C',
    contrastText: '#fff'
};

const WARNING = {
    lighter: '#FFF7CD',
    light: '#FFE16A',
    main: '#FFC107',
    dark: '#B78103',
    darker: '#7A4F01',
    contrastText: '#000'
};

const palette = {
    primary: PRIMARY,
    secondary: SECONDARY,
    info: INFO,
    success: SUCCESS,
    warning: WARNING
};
const config = {
    title: 'Hedgehog',
    logo: Logo,
    palette: palette
};
export default config;
